import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { RewardBox, RewardBoxProps } from './RewardBox';
interface Props {
  items: RewardBoxProps[];
  className?: string;
}
export function RewardBoxes(props) {
  const $ = _c(7);
  if (!props.items.length) {
    return null;
  }
  let t0;
  if ($[0] !== props.className) {
    t0 = mergeClasses("mx-auto grid max-w-292 grid-cols-2 grid-rows-2 gap-4 px-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-8", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.items) {
    t1 = props.items.map(_temp);
    $[2] = props.items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className={t0}>{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(item, index) {
  return <RewardBox key={index} {...item} />;
}